document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const priceTarget = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-add-to-cart]');
  if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Kosárba' : 'Elfogyott';
  }
});
